import { Form, Input, message } from 'antd';
import React, { Component } from 'react';
import { editInfo, getCharter, getInquire } from '../../services/index';
import { getLocalStorage, regularCheck, saveUserInfo } from '../../untils/auth';
import country from '../../untils/country.json';
import SelectMenu from '../selectMenu';

export default class InquireDialog extends Component {
  formRef = React.createRef();
  state = {
    countrySelectShow: false, // 选择国家区号下拉框
    countryCodeList: country, // 国家区号
    phoneCode: 1,
    countryCode: 'US',
    contry: '',
    user: {}, //用户信息
    sourceValue: '',
    paddingLeft: '16px',
  };

  // 模糊搜索国家区号
  filterCode = (e) => {
    let countryCodeList = country.filter((item) => {
      return (
        item.countryName.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1 ||
        item.phoneCode.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1
      );
    });
    this.setState({
      countryCodeList,
    });
  };

  // 选择国家区号
  chooseCode = (item) => {
    let { paddingLeft } = this.state;
    if (item.phoneCode.length > 1) {
      paddingLeft = 16 + (item.phoneCode.length - 1) * 8;
    }
    this.setState({
      countrySelectShow: false,
      countryCodeList: country,
      phoneCode: item.phoneCode,
      countryCode: item.iso2,
      country: item.countryName,
      paddingLeft,
    });
  };

  //补全用户手机号
  submitTelephone = (value) => {
    let { phoneCode, countryCode, country } = this.state;
    let user = getLocalStorage('user') ? JSON.parse(getLocalStorage('user')) : {};
    let userId = getLocalStorage('userId');
    let params = {
      name: user.name,
      surname: user.surName || '1',
      phone: value.phone,
      phoneCode,
      countryIso2: countryCode,
      country,
      photo: user.photo || '1',
    };
    editInfo(userId, params).then((res) => {
      if (res.code) {
        message.success('Successfully modified!');
        let data = {
          account: user?.account,
          name: user.name,
          surname: user.surName,
          phone: value.phone,
          phoneCode,
          countryIso2: countryCode,
          country,
          photo: user.photo,
          membershipCardType: res.data.membershipCardType,
          membershipShuttleNumber: res.data.membershipShuttleNumber,
        };
        saveUserInfo(data);
        const currentParams = this.props.currentParams;
        currentParams.phoneCode = phoneCode;
        currentParams.phone = value.phone;
        this.props.submitInquireAjax(currentParams);
      } else {
        message.error('Modify the failure!');
      }
    });
  };
  // 获取下拉菜单数据
  getSourceValue = (value) => {
    let data = {
      id: this.props.inquireId,
      source: value,
    };
    if (data.id && value) {
      if (this.props.type === 'charterQuote') {
        getCharter(data).then((res) => {
          console.log(res);
        });
      } else {
        getInquire(data).then((res) => {
          console.log(res);
        });
      }
    }
  };

  //提交下拉菜单
  subSelect = () => {
    this.props.history.push(`/inquireDetails/${this.props.routerId}`);
  };

  //关闭弹窗
  closeDialog = () => {
    this.props.closeDialogHandle();
  };

  render() {
    let { phoneCode, countryCode, countrySelectShow, countryCodeList, paddingLeft } = this.state;
    let { dialogType, dialogContent, type, sourceMenuShow } = this.props;
    return (
      <>
        <div className="telephone_dialog">
          {dialogType === 'phoneModle' ? (
            <Form
              ref={this.formRef}
              name="user-form-content"
              autoComplete="off"
              onFinish={this.submitTelephone}
            >
              <div className="dialog_content telephone_content">
                <div className="request-form-title">
                  <div className="public-title">
                    <img src="/imgs/svg/form-tit.svg" alt="title icon" />
                    <span>Reminder</span>
                    <p>Improve your mobile number to help you get in touch faster</p>
                  </div>
                </div>
                <div className="input-text code-phone">
                  <div className="phone-width">
                    <div
                      className="code"
                      onClick={() => this.setState({ countrySelectShow: true })}
                    >
                      <div className="flag">
                        <img
                          src={`${
                            process.env.REACT_APP_ASSET_URL
                          }/country/${countryCode.toLowerCase()}.webp`}
                          alt="flag"
                        />
                      </div>
                      <span>+{phoneCode}</span>
                    </div>
                    <Form.Item
                      name="phone"
                      rules={[
                        {
                          required: true,
                          message: '',
                        },
                        {
                          validator: (rule, value) => {
                            if (regularCheck('numberPhone', value)) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject(
                                new Error('Please enter a valid 6-11 digit phone number')
                              );
                            }
                          },
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        placeholder="Mobile number"
                        style={{ paddingLeft: paddingLeft }}
                      />
                    </Form.Item>
                  </div>
                  {countrySelectShow ? (
                    <>
                      <div className="country-code">
                        <Input placeholder="Search" onChange={(e) => this.filterCode(e)} />
                        <ul>
                          {countryCodeList.map((item, index) => {
                            return (
                              <li key={index} onClick={() => this.chooseCode(item)}>
                                <div>
                                  <img
                                    src={`${
                                      process.env.REACT_APP_ASSET_URL
                                    }/country/${item.iso2.toLowerCase()}.webp`}
                                    alt="flag"
                                  />
                                  <span className="countryname">{item.countryName}</span>
                                </div>
                                <span>{item.phoneCode}</span>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <button
                        className="country-code-mask"
                        onClick={() =>
                          this.setState({
                            countrySelectShow: false,
                            countryCodeList: country,
                          })
                        }
                      ></button>
                    </>
                  ) : null}
                </div>
                <button className="bg-image submit_btn">Submit now</button>
              </div>
            </Form>
          ) : (
            <div className="dialog_content inquire_success">
              <button
                className="close"
                onClick={() => {
                  this.closeDialog();
                }}
              >
                <img
                  src={require('../../assets/imgs/svg/coupons_close.svg').default}
                  alt="close icon"
                />
              </button>
              <div className="request-form-title">
                <div className="public-title">
                  <img src="/imgs/svg/form-tit.svg" alt="title icon" />
                  <span>Reminder</span>
                  <p>{dialogContent}</p>
                  {/*<p style={{margin: "0 0 40px 0"}}>Please view more details in [My Inquiry].</p>*/}
                </div>
              </div>
              {/*{ */}
              {/* sourceMenuShow && (*/}
              {/*  <div style={{'textAlign': 'center'}}>*/}
              {/*    <SelectMenu getSourceValue={this.getSourceValue} width={512} />*/}
              {/*  </div>)*/}
              {/*}*/}
              {getLocalStorage('token') && (
                <button className="bg-image submit_btn" onClick={() => this.subSelect()}>
                  My Inquiries
                </button>
              )}

              {type === 'emptyLeg' ? (
                <a href="/emptyLeg" className="view_more">
                  Go back and view more routes
                </a>
              ) : (
                <a href="/charterQuote" className="view_more">
                  Go back and view more
                </a>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}
